<template>
    <el-dialog
            class="detail-dialog-container"
            :visible.sync="applyDialogVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            append-to-body
            width="50%"
            center>
        <div class="dialog-container flex flex-direction padding">
            <div class="dialog-header flex">
                <div class="dialog-title flex-sub">{{title}}</div>
                <i class="dialog-close el-icon-close" @click="cancel"></i>
            </div>
            <div class="dialog-content flex flex-direction">
                <div class="content" v-html="detail.content"></div>
            </div>
        </div>
    </el-dialog>
</template>

<script>

    import {getMemberManagementDetail} from "../../api/data";

    export default {
        name: "MoreManagementDetailDialog",
        props: {
            applyDialogVisible: {
                type: Boolean,
                default: false
            },
            id: { //详情ID
                type: Number,
            },
            title:{
                type:String,
                default:''
            }
        },
        data() {
            return {
                detail:''

            }
        },
        created() {
            if (this.id)this.init()
        },
        methods: {
            async init(){
                let _data = await getMemberManagementDetail(this.id)
                this.detail = _data.data
            },
            cancel() {
                this.$emit('watchState', false)
            },

        },
        watch: {
            id() {
               if (this.id)this.init()
            }
        }
    }
</script>

<style scoped lang="scss">
    .detail-dialog-container {
        .dialog-container {
            .dialog-header {
                height: 55px;
                .dialog-title {
                    font-size: 18px;
                    font-weight: bold;
                    color: #0a2240;
                }
                .dialog-close {
                    font-size: 21px;
                    color: #0a2240;
                    font-weight: bold;
                    cursor: pointer;
                }
            }
            .dialog-content {
                height: 505px;
                padding: 0 20px;
                overflow-y: scroll;
                &::-webkit-scrollbar {
                    background: transparent;
                    width: 2px;
                }

                &::-webkit-scrollbar-thumb {
                    background: #0a2240;
                    height: 30px;
                }
                .content {
                    font-size: 16px;
                    line-height: 36px;
                    color: #666666;
                    text-align: justify;
                }
            }
        }
    }
</style>